module.exports = __webpack_public_path__ + "static/media/computador_br.bd680a0f.png";